import React, { useState, useEffect } from 'react';
import ConfirmDialog from '../branches/ConfirmDialog';
import styles from '../branches/TriggerReleaseDialog.module.css';
import { triggerPostReleaseVersionBump } from '../../api/releases';
import { setAlert } from '../../helpers/alerts';

const ICO_TAG = 'M20.59 13.41 12 22l-9-9-2-9 9 2 9 9a2 2 0 0 1 0 2.83z M7.5 7.5h.01';

const TAG_ICON_STYLE = {
  background: 'linear-gradient(135deg, #162044, #1570EF)',
  color: '#fff',
  border: 'none',
};

export default function TriggerVersionBumpDialog({ open, onClose, release, onTriggered }) {
  const [version,    setVersion]    = useState('');
  const [error,      setError]      = useState('');
  const [triggering, setTriggering] = useState(false);

  useEffect(() => {
    if (open) { setVersion(''); setError(''); setTriggering(false); }
  }, [open]);

  const validate = (v) => /^\d+\.\d+\.\d+(-[A-Za-z0-9]+)?$/.test(v);

  const handleChange = (e) => {
    const v = e.target.value;
    setVersion(v);
    setError(validate(v) ? '' : 'Must match X.Y.Z, optionally with a -SNAPSHOT-style suffix');
  };

  const handleConfirm = () => {
    if (!validate(version)) return;
    setTriggering(true);
    triggerPostReleaseVersionBump(release.version, { version })
      .then((r) => {
        setAlert('Version bump', `Version-bump commits triggered on ${release.branch_version}`, 'success');
        onTriggered?.(r.release);
        onClose();
      })
      .catch((err) => {
        setAlert('Version bump error', err, 'danger');
        setTriggering(false);
      });
  };

  return (
    <ConfirmDialog
      open={open}
      icon={ICO_TAG}
      iconStyle={TAG_ICON_STYLE}
      title="Bump application version"
      message={`Commits a version bump directly onto branch ${release?.branch_version} for every component.`}
      confirmLabel="Trigger version bump"
      confirming={triggering}
      confirmingLabel="Triggering…"
      onConfirm={handleConfirm}
      onCancel={onClose}
    >
      <div className={styles.field}>
        <label className={styles.label}>Version</label>
        <input
          className={`${styles.input}${error ? ` ${styles.inputError}` : ''}`}
          value={version}
          onChange={handleChange}
          autoFocus
          placeholder="1.13.2 or 1.13.2-SNAPSHOT"
        />
        {error
          ? <span className={styles.hint} style={{ color: 'var(--error-600)' }}>{error}</span>
          : <span className={styles.hint}>Must match X.Y.Z format</span>
        }
      </div>
    </ConfirmDialog>
  );
}
